import React from "react";
import Register from "./Register";
import Translation from "../i18n";

class Intro extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nameReplacement: false,
            fetch: false,
            answered: false
        };
        this.setNameReplacement = this.setNameReplacement.bind(this);
    }

    setNameReplacement(name) {
        this.setState({nameReplacement: name})
    }

    render() {

        const description = this.props.description;
        const replacedDescription = (this.state.nameReplacement ? description.replaceAll('{firstname}', this.state.nameReplacement) : description);
		const questionnaireId = this.props.questionnaireId;

        return (
            <>
                <Register setNameReplacement={(p) => this.setNameReplacement(p)} questionnaireId={questionnaireId} />
                <h1 className="text-center text-primary text-strong">
                    <Translation i18n="questionnaireSubHeader" />
                </h1>
                <div className="row align-items-center">
                    <div className={this.props.image ? 'col-md-6' : 'col-12'}>
                        <span className="intro-text" dangerouslySetInnerHTML={{__html: replacedDescription}} />
                    </div>
                    {this.props.image &&
                        <div className="col-md-6">
                            <img src={this.props.image} className="img-fluid" alt="" />
                        </div>
                    }
                </div>
            </>
        );
    }
}

export default Intro;
